"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.SYMBOL_SIZE = exports.MAX_BODY_SIZE = void 0;
var Byte = function (a) {
  return a[a.Kb = 1000] = "Kb", a[a.Mb = 1e3 * a.Kb] = "Mb", a[a.Gb = 1e3 * a.Mb] = "Gb", a;
}(Byte || {});
var MAX_BODY_SIZE = exports.MAX_BODY_SIZE = 10 * Byte.Mb,
  SYMBOL_SIZE = exports.SYMBOL_SIZE = 4;